import React, { Component } from "react";

import { Row, Col, Popover } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import {
  InstagramOutlined,
  MailOutlined,
  LinkedinOutlined,
} from "@ant-design/icons";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/HumanResource/HumanResource.css";

const ManagerCard = {
  borderRadius: "20px",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
};

const managerMail = (
  <div>
    <p></p>
  </div>
);
const ChairmanTab = (props) => {
  return props.size === "laptopdesktop" ? (
    <div>
      <Row>
        <Col span={4}></Col>
        <Col span={16}>
          <div style={ManagerCard}>
            <Row>
              <Col
                span={17}
                style={{
                  backgroundColor: "#f6f6f6",
                  borderRadius: "20px 0 0 20px",
                }}
              >
                <Margin top={3}></Margin>
                <div style={{ paddingRight: "30px", paddingLeft: "30px" }}>
                  <p className="textParagraph">
                    <p style={{ fontWeight: "bold" }}>تحصیلات </p>
                    • دکتری مدیریت با گرایش تولید و عملیات <br />• رساله دکتری
                    با عنوان (نقش بیمه در پایداری مشاغل خرد)
                    <p style={{ fontWeight: "bold", marginTop: "5%" }}>سوابق</p>
                    • دبيركل سنديكاي بيمه گران ٤ سال
                    <br />
                    • ريس كل بيمه مركزي ٣ سال
                    <br />• ريس شوراي‌عالي بيمه ٣ سال
                    <br />• استاندار مازندران
                    <br />• مدیرعامل صندوق مهر امام رضا
                    <br />
                    • معاون پشتیبانی، حقوقی و امور مجلس وزارت تعاون
                    <br />• مدیرعامل صندوق تعاون کشور
                    <br />• رئیس هیئت مدیره صندوق تعاون کشور
                    <br />• مدیرعامل شرکت صنایع ملی گاز
                    <br />• معاون برنامه ریزی و مالی اداری استانداری استان
                    گلستان
                    <br />• فرماندار قائمشهر (استان مازندران)
                    <br />• فرماندار کردکوی (استان گلستان)
                    <br />• رئیس هیئت مدیره و مدیرعامل شرکت ایران گاز کشور (گروه
                    شرکت‌های 24 گانه استانی)
                    <br />• معاون شرکت ملی پخش فرآورده‌های نفتی استان سمنان
                    <br />• رئیس شرکت ملی پخش فرآورده‌های نفتی ناحیه آمل
                    <br />• رئیس شرکت ملی پخش فرآورده‌های نفتی ناحیه ساری
                    <br />• بخشدار محمودآباد مازندران
                    <br />• بخشدار لاریجان آمل
                    <p style={{ fontWeight: "bold", marginTop: "5%" }}>
                      تألیفات
                    </p>
                    • رساله دکتری با عنوان (نقش بیمه در پایداری مشاغل خرد)
                    <br />
                    • پایان‌نامه کارشناسی ارشد با عنوان (بررسی ریشه‌های بحران
                    کارگری در نساجی قائم شهر)
                    <br />• کتاب جلوه‌های امید در صنعت بیمه
                    <br />• مجموعه آموزشی دانستنی‌های پایدارسازی مشاغل در ایران
                    <p style={{ fontWeight: "bold", marginTop: "5%" }}>
                      مقالات علمی
                    </p>
                    • بررسی اثرات صلاحیت و توان سنجی (اهلیت سنجی) مشتریان متقاضی
                    وام برای پایداری سرمایه‌گذاری مشاغل خرد
                    <br />
                    • نقش مشاغل خرد در تحقق کار شایسته در ایران
                    <br />• نقش مشاوره شغلی در پایداری مشاغل خرد، خوداشتغالی و
                    خانگی
                    <br />• بررسی روند رشد خوداشتغالی در بخش‌های مختلف کشور
                    <br />• تبیین مسیر عوامل مؤثر بر پایداری کسب‌وکار خرد و
                    ایجاد اشتغال
                    <br />• نقش و جایگاه بیمه‌های تجاری در پایداری کسب‌وکارهای
                    خرد
                    <br />• هدایت پایان‌نامه‌های متعدد ازجمله پایان‌نامه‌های
                    تعدادی از دانشجویان با گرایش بیمه
                    <p style={{ fontWeight: "bold", marginTop: "5%" }}>
                      عضویت در شرکت‌ها و مجامع
                    </p>
                    • عضو هیئت رئیسه اتاق تعاون ایران
                    <br />
                    • رئیس هیئت مدیره شرکت زنجیره‌ای رفاه
                    <br />• رئیس هیئت مدیره شرکت ایران گاز
                    <br />• عضو خانه مدیران
                    <br />• عضو خانه صنعت
                    <br />• عضو جامعه اسلامی مهندسین
                    <br />• دبیر انجمن کارفرمایان گاز مایع ایران
                  </p>
                </div>
              </Col>
              <Col
                span={7}
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "0 20px 20px 0",
                }}
              >
                <Margin top={3}></Margin>
                <Center>
                  <img
                    className="humanResourcePersonPic"
                    src={require("../../../Imgs/AboutUs/HumanResource/chairman.jpg")}
                  />
                </Center>
                <Margin top={2}></Margin>
                <Center>
                  <Row style={{ direction: "rtl", textAlign: "right" }}>
                    <div
                      className="personRightBorder"
                      style={{
                        direction: "rtl",
                        textAlign: "right",
                        marginRight: "6.5px",
                      }}
                    ></div>
                    <div style={{ marginTop: "-2.5px" }}>
                      <strong
                        style={{
                          fontFamily: "IranSans",
                          fontSize: ".95em",
                          color: "#174561",
                          paddingRight: "5px",
                        }}
                      >
                        دكتر سيد محمد كريمي
                      </strong>
                      <p
                        style={{
                          fontFamily: "IranSans",
                          fontSize: ".85em",
                          color: "#8d8d8d",
                          paddingRight: "5px",
                        }}
                      >
                        رئیس هیئت مدیره
                      </p>
                    </div>
                  </Row>
                </Center>
                <Margin top={2}></Margin>
                <Center>
                  <a>
                    <LinkedinOutlined
                      style={{
                        fontSize: "1.3em",
                        margin: "5px",
                        color: "#2867B2",
                      }}
                    />
                  </a>
                  <Popover content={managerMail} placement="bottom">
                    <a>
                      <MailOutlined
                        style={{
                          fontSize: "1.3em",
                          margin: "5px",
                          color: "#4a00a0",
                        }}
                      />
                    </a>
                  </Popover>
                  <a href="">
                    <InstagramOutlined
                      style={{
                        fontSize: "1.3em",
                        margin: "5px",
                        color: "#E1306C",
                      }}
                    />
                  </a>
                </Center>
                <Margin top={2}></Margin>
                <Center>
                  <p
                    style={{
                      fontFamily: "IranSans",
                      fontSize: ".85em",
                      color: "#8d8d8d",
                      paddingRight: "5px",
                    }}
                  >
                    شماره تماس: 84229999-۰۲۱
                  </p>
                </Center>
              </Col>
            </Row>
          </div>
        </Col>
        <Col span={4}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <div style={ManagerCard}>
            <Row>
              <Col
                span={16}
                style={{
                  backgroundColor: "#f6f6f6",
                  borderRadius: "20px 0 0 20px",
                }}
              >
                <Margin top={3}></Margin>
                <div style={{ paddingRight: "30px", paddingLeft: "30px" }}>
                  <p className="textParagraphTablet">
                    <p style={{ fontWeight: "bold" }}>تحصیلات </p>
                    • دکتری مدیریت با گرایش تولید و عملیات <br />• رساله دکتری
                    با عنوان (نقش بیمه در پایداری مشاغل خرد)
                    <p style={{ fontWeight: "bold", marginTop: "5%" }}>سوابق</p>
                    • دبيركل سنديكاي بيمه گران ٤ سال
                    <br />
                    • ريس كل بيمه مركزي ٣ سال
                    <br />• ريس شوراي‌عالي بيمه ٣ سال
                    <br />• استاندار مازندران
                    <br />• مدیرعامل صندوق مهر امام رضا
                    <br />
                    • معاون پشتیبانی، حقوقی و امور مجلس وزارت تعاون
                    <br />• مدیرعامل صندوق تعاون کشور
                    <br />• رئیس هیئت مدیره صندوق تعاون کشور
                    <br />• مدیرعامل شرکت صنایع ملی گاز
                    <br />• معاون برنامه ریزی و مالی اداری استانداری استان
                    گلستان
                    <br />• فرماندار قائمشهر (استان مازندران)
                    <br />• فرماندار کردکوی (استان گلستان)
                    <br />• رئیس هیئت مدیره و مدیرعامل شرکت ایران گاز کشور (گروه
                    شرکت‌های 24 گانه استانی)
                    <br />• معاون شرکت ملی پخش فرآورده‌های نفتی استان سمنان
                    <br />• رئیس شرکت ملی پخش فرآورده‌های نفتی ناحیه آمل
                    <br />• رئیس شرکت ملی پخش فرآورده‌های نفتی ناحیه ساری
                    <br />• بخشدار محمودآباد مازندران
                    <br />• بخشدار لاریجان آمل
                    <p style={{ fontWeight: "bold", marginTop: "5%" }}>
                      تألیفات
                    </p>
                    • رساله دکتری با عنوان (نقش بیمه در پایداری مشاغل خرد)
                    <br />
                    • پایان‌نامه کارشناسی ارشد با عنوان (بررسی ریشه‌های بحران
                    کارگری در نساجی قائم شهر)
                    <br />• کتاب جلوه‌های امید در صنعت بیمه
                    <br />• مجموعه آموزشی دانستنی‌های پایدارسازی مشاغل در ایران
                    <p style={{ fontWeight: "bold", marginTop: "5%" }}>
                      مقالات علمی
                    </p>
                    • بررسی اثرات صلاحیت و توان سنجی (اهلیت سنجی) مشتریان متقاضی
                    وام برای پایداری سرمایه‌گذاری مشاغل خرد
                    <br />
                    • نقش مشاغل خرد در تحقق کار شایسته در ایران
                    <br />• نقش مشاوره شغلی در پایداری مشاغل خرد، خوداشتغالی و
                    خانگی
                    <br />• بررسی روند رشد خوداشتغالی در بخش‌های مختلف کشور
                    <br />• تبیین مسیر عوامل مؤثر بر پایداری کسب‌وکار خرد و
                    ایجاد اشتغال
                    <br />• نقش و جایگاه بیمه‌های تجاری در پایداری کسب‌وکارهای
                    خرد
                    <br />• هدایت پایان‌نامه‌های متعدد ازجمله پایان‌نامه‌های
                    تعدادی از دانشجویان با گرایش بیمه
                    <p style={{ fontWeight: "bold", marginTop: "5%" }}>
                      عضویت در شرکت‌ها و مجامع
                    </p>
                    • عضو هیئت رئیسه اتاق تعاون ایران
                    <br />
                    • رئیس هیئت مدیره شرکت زنجیره‌ای رفاه
                    <br />• رئیس هیئت مدیره شرکت ایران گاز
                    <br />• عضو خانه مدیران
                    <br />• عضو خانه صنعت
                    <br />• عضو جامعه اسلامی مهندسین
                    <br />• دبیر انجمن کارفرمایان گاز مایع ایران
                  </p>
                </div>
              </Col>
              <Col
                span={8}
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "0 20px 20px 0",
                }}
              >
                <Margin top={3}></Margin>
                <Center>
                  <img
                    className="humanResourcePersonPic"
                    src={require("../../../Imgs/AboutUs/HumanResource/chairman.jpg")}
                  />
                </Center>
                <Margin top={2}></Margin>
                <Center>
                  <Row style={{ direction: "rtl", textAlign: "right" }}>
                    <div
                      className="personRightBorder"
                      style={{
                        direction: "rtl",
                        textAlign: "right",
                        marginRight: "6.5px",
                      }}
                    ></div>
                    <div style={{ marginTop: "-2.5px" }}>
                      <strong
                        style={{
                          fontFamily: "IranSans",
                          fontSize: ".85em",
                          color: "#174561",
                          paddingRight: "5px",
                        }}
                      >
                        دكتر سيد محمد كريمي
                      </strong>
                      <p
                        style={{
                          fontFamily: "IranSans",
                          fontSize: ".75em",
                          color: "#8d8d8d",
                          paddingRight: "5px",
                        }}
                      >
                        رئیس هیئت مدیره
                      </p>
                    </div>
                  </Row>
                </Center>
                <Margin top={2}></Margin>
                <Center>
                  <a>
                    <LinkedinOutlined
                      style={{
                        fontSize: "1.3em",
                        margin: "5px",
                        color: "#2867B2",
                      }}
                    />
                  </a>
                  <Popover content={managerMail} placement="bottom">
                    <a>
                      <MailOutlined
                        style={{
                          fontSize: "1.3em",
                          margin: "5px",
                          color: "#4a00a0",
                        }}
                      />
                    </a>
                  </Popover>
                  <a href="">
                    <InstagramOutlined
                      style={{
                        fontSize: "1.3em",
                        margin: "5px",
                        color: "#E1306C",
                      }}
                    />
                  </a>
                </Center>
                <Margin top={2}></Margin>
                <Center>
                  <p
                    style={{
                      fontFamily: "IranSans",
                      fontSize: ".75em",
                      color: "#8d8d8d",
                      paddingRight: "5px",
                    }}
                  >
                    شماره تماس: 84229999-۰۲۱
                  </p>
                </Center>
              </Col>
            </Row>
          </div>
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  ) : (
    <div>
      <Row>
        <Col span={1}></Col>
        <Col span={22}>
          <div
            style={{
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              backgroundColor: "#fff",
              height: "100%",
              borderRadius: "20px",
            }}
          >
            <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px" }}>
              <Center>
                <Margin top={3}>
                  <Center>
                    <Margin top={2}>
                      <Center>
                        <img
                          style={{
                            width: "150px",
                            height: "150px",
                            borderRadius: "50%",
                          }}
                          src={require("../../../Imgs/AboutUs/HumanResource/chairman.jpg")}
                        />
                      </Center>
                    </Margin>
                  </Center>
                  <Center>
                    <Margin top={2}>
                      <Center>
                        <strong
                          style={{
                            fontFamily: "IranSans",
                            fontSize: ".8em",
                            color: "#174561",
                            paddingRight: "10px",
                          }}
                        >
                          دكتر سيد محمد كريمي
                        </strong>
                      </Center>
                      <Center>
                        <p
                          style={{
                            fontFamily: "IranSans",
                            fontSize: ".75em",
                            color: "#8d8d8d",
                            paddingRight: "10px",
                            marginTop: "5px",
                            textAlign: "center",
                          }}
                        >
                          رئیس هیئت مدیره
                        </p>
                      </Center>
                    </Margin>
                  </Center>
                </Margin>
              </Center>
              <Center>
                <div className="cardTitleHR"></div>
              </Center>
              <Margin top={2}></Margin>
              <div
                style={{
                  padding: "15px",
                  backgroundColor: "#fff",
                  borderRadius: "0 0 20px 20px",
                }}
              >
                <p className="textParagraphMobile">
                  <p style={{ fontWeight: "bold" }}>تحصیلات </p>
                  • دکتری مدیریت با گرایش تولید و عملیات <br />• رساله دکتری با
                  عنوان (نقش بیمه در پایداری مشاغل خرد)
                  <p style={{ fontWeight: "bold", marginTop: "5%" }}>سوابق</p>
                  • دبيركل سنديكاي بيمه گران ٤ سال
                  <br />
                  • ريس كل بيمه مركزي ٣ سال
                  <br />• ريس شوراي‌عالي بيمه ٣ سال
                  <br />• استاندار مازندران
                  <br />• مدیرعامل صندوق مهر امام رضا
                  <br />
                  • معاون پشتیبانی، حقوقی و امور مجلس وزارت تعاون
                  <br />• مدیرعامل صندوق تعاون کشور
                  <br />• رئیس هیئت مدیره صندوق تعاون کشور
                  <br />• مدیرعامل شرکت صنایع ملی گاز
                  <br />• معاون برنامه ریزی و مالی اداری استانداری استان گلستان
                  <br />• فرماندار قائمشهر (استان مازندران)
                  <br />• فرماندار کردکوی (استان گلستان)
                  <br />• رئیس هیئت مدیره و مدیرعامل شرکت ایران گاز کشور (گروه
                  شرکت‌های 24 گانه استانی)
                  <br />• معاون شرکت ملی پخش فرآورده‌های نفتی استان سمنان
                  <br />• رئیس شرکت ملی پخش فرآورده‌های نفتی ناحیه آمل
                  <br />• رئیس شرکت ملی پخش فرآورده‌های نفتی ناحیه ساری
                  <br />• بخشدار محمودآباد مازندران
                  <br />• بخشدار لاریجان آمل
                  <p style={{ fontWeight: "bold", marginTop: "5%" }}>تألیفات</p>
                  • رساله دکتری با عنوان (نقش بیمه در پایداری مشاغل خرد)
                  <br />
                  • پایان‌نامه کارشناسی ارشد با عنوان (بررسی ریشه‌های بحران
                  کارگری در نساجی قائم شهر)
                  <br />• کتاب جلوه‌های امید در صنعت بیمه
                  <br />• مجموعه آموزشی دانستنی‌های پایدارسازی مشاغل در ایران
                  <p style={{ fontWeight: "bold", marginTop: "5%" }}>
                    مقالات علمی
                  </p>
                  • بررسی اثرات صلاحیت و توان سنجی (اهلیت سنجی) مشتریان متقاضی
                  وام برای پایداری سرمایه‌گذاری مشاغل خرد
                  <br />
                  • نقش مشاغل خرد در تحقق کار شایسته در ایران
                  <br />• نقش مشاوره شغلی در پایداری مشاغل خرد، خوداشتغالی و
                  خانگی
                  <br />• بررسی روند رشد خوداشتغالی در بخش‌های مختلف کشور
                  <br />• تبیین مسیر عوامل مؤثر بر پایداری کسب‌وکار خرد و ایجاد
                  اشتغال
                  <br />• نقش و جایگاه بیمه‌های تجاری در پایداری کسب‌وکارهای خرد
                  <br />• هدایت پایان‌نامه‌های متعدد ازجمله پایان‌نامه‌های
                  تعدادی از دانشجویان با گرایش بیمه
                  <p style={{ fontWeight: "bold", marginTop: "5%" }}>
                    عضویت در شرکت‌ها و مجامع
                  </p>
                  • عضو هیئت رئیسه اتاق تعاون ایران
                  <br />
                  • رئیس هیئت مدیره شرکت زنجیره‌ای رفاه
                  <br />• رئیس هیئت مدیره شرکت ایران گاز
                  <br />• عضو خانه مدیران
                  <br />• عضو خانه صنعت
                  <br />• عضو جامعه اسلامی مهندسین
                  <br />• دبیر انجمن کارفرمایان گاز مایع ایران
                </p>

                <a>
                  <LinkedinOutlined
                    style={{
                      fontSize: "1.3em",
                      margin: "5px",
                      color: "#2867B2",
                    }}
                  />
                </a>
                <Popover content={managerMail} placement="bottom">
                  <a>
                    <MailOutlined
                      style={{
                        fontSize: "1.3em",
                        margin: "5px",
                        color: "#4a00a0",
                      }}
                    />
                  </a>
                </Popover>
                <a href="">
                  <InstagramOutlined
                    style={{
                      fontSize: "1.3em",
                      margin: "5px",
                      color: "#E1306C",
                    }}
                  />
                </a>
                <p
                  style={{
                    fontFamily: "IranSans",
                    fontSize: ".85em",
                    color: "#8d8d8d",
                    paddingRight: "5px",
                  }}
                >
                  شماره تماس: 84229999-۰۲۱
                </p>
              </div>
            </div>
          </div>
        </Col>
        <Col span={1}></Col>
      </Row>
      <Margin bottom={4}></Margin>
    </div>
  );
};

export default ChairmanTab;
